export interface IMMLKeyListItem {
    recordId: number, 
    mmlKey: string,
    requestedBy: string,
    postedDate: string, 
    status: string,
    recordType: MMLKeyListRecordType,
    comment?: string,
    ccFraudInd: number
}
export interface IMMLSimpleResponse
{
    successful: boolean,
    msg?: string
}

export interface IMMLAuditPrintInputs
{
    patientId: number,
    mmlKey: string
}

export interface IMMLDeleteKeyInputs
{
    patientId: number,
    mmlKey: string,
    comment: string
}

export interface IMMLAuditListInputs
{
    patientId: number,
    mmlKey: string
}

export interface IMMLAuditListItem
{
    auditId: number,
    recordId: number,
    description: string,
    oldValue: string,
    newValue: string,
    userId: string,
    postedDate: string
}

export interface IMMLSendTokenInputs
{
    patientId: number,
    requestedBy: string,
    sendType: string,
    email?: string,
    phone?: string
}

export interface IMMLSendKeyInputs
{
    patientId: number,
    requestedBy: string,
    sendType: string,
    email?: string,
    phone?: string
}

export interface IMMLCreateAccountInputs
{
    idType: string,
    identifier: number,
    requestedBy: string,
    mmlType: string,
    email: string,
    phone: string,
    token: string
}

export interface IMMLCreateAccountResponse {
    successful: boolean,
    responseMessage: string,
    mmlKey?: string
}

export interface IMMLCreateKeyOnlyInputs
{
    patientId: number,
    requestedBy: string
}

export interface IMMLCreateKeyOnlyResponse
{
    successful: boolean,
    msg?: string,
    mmlKey?: string
}

export enum MMLAdminConnectionType {
    CreateEmail,
    CreatePhone,
    GenerateEmail,
    GeneratePhone,
    GenerateLetter
}

export enum MMLAdminSendType {
    EmailToken = "E",
    PhoneToken = "P",
    EmailKey = "M",
    PhoneKey = "T"
}

export enum MMLKeyListRecordType {
    Key = 0,
    OptOut = 1,
    MMLWelcomePrint = 2,
    MMLIntakeWelcomeSent = 3,
    KeyEmailText = 4
}
